import Dexie from 'dexie';

const db = new Dexie('trackr');
db.version(1).stores({
  diary: '++id, date, meal',
  exercise: '++id, date',
  weight: 'date',
  water: 'date',
});

export default db;
